module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "3shield-update.22ef117d.svg";